import { render, staticRenderFns } from "./MatrixAdd.vue?vue&type=template&id=98a4cc06&"
import script from "./MatrixAdd.vue?vue&type=script&lang=js&"
export * from "./MatrixAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports